import { CircularProgress } from '@mui/material';
import { Button as BlockheadButton } from '@sparemin/blockhead';
import styled from 'styled-components';

export const Button = styled(BlockheadButton)`
  white-space: nowrap;
`;

export const Loader = styled(CircularProgress)`
  position: absolute;
  width: 40px;
  height: 40px;
  top: 100px;
  left: 50%;
  transform: translate(-50%, 0);
`;
